<template>
  <div class="home-container mt-4">
    <div class="left-side-container">
      <div class="d-flex flex-column align-start justify-between">
        <HomeHeader
          :is-admin-on="isAdminOn"
          :loading="pageLoading"
        />
        <!-- We need two keyed instances of HomeTabs in order for tabs
          to work when toggling between admin and editor views -->
        <HomeTabs
          v-if="isAdminOn"
          key="admin-tabs"
          is-admin-on
          :tabs="tabs"
          :loading="pageLoading"
        />
        <HomeTabs
          v-else
          key="non-admin-tabs"
          :tabs="tabs"
          :loading="pageLoading"
        />
      </div>
      <HomeLearn :loading="pageLoading" />
    </div>
    <div class="right-side-container">
      <HomeAdminButton
        v-show="isAdminRole"
        :is-admin-on="isAdminOn"
        :loading="pageLoading"
        @update-admin-view="setIsAdminOn($event)"
      />
      <HomeCollaborateAndRecentViews
        :loading="pageLoading"
        :is-admin-on="isAdminOn"
        :is-admin-role="isAdminRole"
      />
    </div>
  </div>
</template>

<script>
import HomeHeader from '@/components/home/HomeHeader/HomeHeader.vue';
import HomeTabs from '@/components/home/HomeTabs/HomeTabs.vue';
import HomeLearn from '@/components/home/HomeLearn/HomeLearn.vue';
import HomeAdminButton from '@/components/home/HomeAdminButton/HomeAdminButton.vue';
import HomeCollaborateAndRecentViews from '@/components/home/HomeCollaborateAndRecentViews/HomeCollaborateAndRecentViews.vue';
import { mapActions, mapState } from 'pinia';
import { useAppAuthData } from '@/stores/app/authData';
import { useHome } from '@/stores/home/home';
import { tabsData } from '@/components/home/HomeTabs/tabsData';
import { useAppLoading } from '@/stores/app/loading';

export default {
  name: 'HomeView',
  components: {
    HomeHeader,
    HomeTabs,
    HomeLearn,
    HomeAdminButton,
    HomeCollaborateAndRecentViews,
  },
  emits: ['track-page-load'],
  computed: {
    ...mapState(useHome, ['isAdminOn']),
    ...mapState(useAppAuthData, ['authData']),
    ...mapState(useAppLoading, ['pageLoading']),
    projectName() { return this.authData.projectName; },
    isAdminRole() { return this.authData.role === 'admin' || this.authData.isSuperuser; },
    tabs() {
      return tabsData(this.isAdminOn);
    },
  },
  watch: {
    isAdminRole: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.setIsAdminOn(true);
        }
      },
    },
  },
  async mounted() {
    await this.initHome();
    this.$emit('track-page-load', { page: 'Home' });
  },
  methods: {
    ...mapActions(useHome, ['setIsAdminOn', 'initHome']),
  },
};
</script>

<style lang="less" scoped>
.home-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
  min-width: 1288px;
  max-width: 1488px;
  padding: 0 44px;
  margin: 0 auto;
}

.left-side-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  height: 100%;
}

.right-side-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  height: 100%;
}
</style>
